<template>
  <svg width="18"
       height="17"
       viewBox="0 0 18 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M2.94434 16.8809H15.0469C16.9541 16.8809 17.9473 15.8965 17.9473 14.0156V3.31934C17.9473 1.43848 16.9541 0.454102 15.0469 0.454102H2.94434C1.0459 0.454102 0.0527344 1.42969 0.0527344 3.31934V14.0156C0.0527344 15.8965 1.0459 16.8809 2.94434 16.8809ZM2.93555 15.1318C2.20605 15.1318 1.80176 14.7539 1.80176 13.9805V5.89453C1.80176 5.12109 2.20605 4.74316 2.93555 4.74316H15.0557C15.7852 4.74316 16.1895 5.12109 16.1895 5.89453V13.9805C16.1895 14.7539 15.7852 15.1318 15.0557 15.1318H2.93555ZM4.43848 7.89844H13.5703C13.8867 7.89844 14.124 7.65234 14.124 7.32715C14.124 7.01953 13.8867 6.78223 13.5703 6.78223H4.43848C4.11328 6.78223 3.87598 7.01953 3.87598 7.32715C3.87598 7.65234 4.11328 7.89844 4.43848 7.89844ZM4.43848 10.4912H13.5703C13.8867 10.4912 14.124 10.2539 14.124 9.94629C14.124 9.62988 13.8867 9.375 13.5703 9.375H4.43848C4.11328 9.375 3.87598 9.62988 3.87598 9.94629C3.87598 10.2539 4.11328 10.4912 4.43848 10.4912ZM4.43848 13.084H10.2041C10.5205 13.084 10.7578 12.8467 10.7578 12.5391C10.7578 12.2227 10.5205 11.9766 10.2041 11.9766H4.43848C4.11328 11.9766 3.87598 12.2227 3.87598 12.5391C3.87598 12.8467 4.11328 13.084 4.43848 13.084Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PrimaryIcon',
  props: {
    width: {
      type: Number,
      default: 14
    },
    height: {
      type: Number,
      default: 14
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
